import {
  Avatar,
  AvatarBadge,
  Box,
  Button,
  Container,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Tooltip,
} from "@chakra-ui/react";
import { List } from "@phosphor-icons/react";

import { useAppConfig, useAuth } from "../../../context";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NotificationModel } from "../../Nofitication/NotificationModel";
import antaiaLogoTeal from "../../../assets/img/antaia-logo.png";
import esg360Logo from "../../../assets/img/esg-teal-logo.png";

import { useRightSidebar } from "../../../context/RightSidebarContext";
import AIAssistPanel from "pages/ISSB/components/AIAssistPanel/AIAssistPanel";
import { CaretLeft, Sparkle } from "@phosphor-icons/react";
import { colors } from "theme/foundations/colors";
import { i18n } from "utils/text-utils";
import { useQuery } from "react-query";
import { organizationService } from "api/organization-administration";
import { useDispatch } from "react-redux";
/**
 * Top navbar
 */
function Navbar() {
  // control hamburger show/hide behaviour for mobile devices
  const { toggleSidebar, storedSidebarState } = useAppConfig();

  // default to "esg", either antaia or esg.
  const branding = process.env.REACT_APP_BRANDING || "esg";

  return (
    <Container id="navbar" minW="100vw" paddingBlock="4" pl={4} pr={2}>
      <Flex gap="2" justifyContent="space-between" alignItems="center">
        <Flex alignItems="center" gap={3}>
          <Tooltip label={storedSidebarState ? "Collapse sidebar" : "Expand sidebar"} placement="bottom" openDelay={300}>
            <IconButton
              aria-label="Toggle sidebar"
              variant="ghost"
              size="sm"
              fontSize="xl"
              color="gray.600"
              _hover={{ bg: "gray.100" }}
              onClick={() => toggleSidebar()}
              icon={<List size={20} weight="bold" />}
            />
          </Tooltip>
          <Image height="36px" src={branding === "esg" ? esg360Logo : antaiaLogoTeal} alt="company-logo" />
        </Flex>
        <Flex direction="row" gap={1} alignItems="center">
          <TopRightNav />
          <UserNav />
        </Flex>
      </Flex>
    </Container>
  );
}

/**
 * The ESG360° company name
 */
export const ESG360 = "ESG360°";

/**
 * Top right navigation menu
 * See https://www.figma.com/design/uDql1qJTNBIvGnFDsOpWV4/ESG360-AIR?node-id=121-12580&t=hcRCq2SjYEdBbZO1-0
 */
function TopRightNav() {
  const { doClose } = useRightSidebar();

  // To Close the right hand sidebar when ESC key is pressed on the keyboard
  useEffect(()=>{
    const handleKeyDown = (event) => {
      if(event.key === 'Escape') {
        doClose();
      }
    }

    // Adding the event listner to the window
    window.addEventListener('keydown', handleKeyDown);

    // Cleaning up the event listner on page unmount
    return () => window.removeEventListener('keydown', handleKeyDown);
  },[doClose])

  return (
    <Box id="top-right-nav" display="flex" alignItems="center">
      <NotificationModel />
    </Box>
  );
}

/**
 * User navigation menu - who is logged in? + logout
 * This will move to the bottom of the left sidebar:
 * see https://www.figma.com/design/uDql1qJTNBIvGnFDsOpWV4/ESG360-AIR?node-id=121-12580&t=hcRCq2SjYEdBbZO1-0
 */
function UserNav() {
  const { t } = useTranslation("translation", {
    keyPrefix: "appHeader",
  });
  const { logout, user } = useAuth();
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.clear();
    logout();
  };

  const { getAccessTokenSilently } = useAuth();

  const org_id = user?.org_id;
  const { data: orgData } = useQuery({
    queryKey: ["org", org_id],
    queryFn: () => getAccessTokenSilently().then(() => organizationService.get(org_id)),
    enabled: !!org_id,
  });


  return (
    <Menu>
      <MenuButton
        fontSize="14px" // temp fix with fixed font size, chakra theme value is not working here
        as={Button}
        variant="ghost"
      >
        <HStack>
          <Avatar size="xs" name={user.name}>
            <AvatarBadge boxSize="1em" bg="green.500" />
          </Avatar>
          {/*<Text display={{ base: "none", lg: "block" }}>{user.name}</Text>*/}
        </HStack>
      </MenuButton>
      <MenuList>
        <MenuGroup title={user.name}>
          <MenuItem fontSize="14px" title={org_id}>
            {orgData?.name || org_id}
          </MenuItem>
          <MenuItem fontSize="14px" onClick={() => handleLogout()}>
            Logout
          </MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
}

function AIAssistButton() {
  const { setRightSidebar, doOpen, isOpen, doClose, activationId } = useRightSidebar();
  const t = i18n({ keyPrefix: "appHeader" });

  const toggleAI = () => {
    if ("AI" === activationId && isOpen) {
      doClose();
    } else {
      setRightSidebar(<AIAssistPanel />);
      doOpen("AI");
    }
  };

  return (
    <Button
      variant="ghost"
      onClick={toggleAI}
      title={t("AI Assistant")}
      fontSize="14px"
      _hover={{ bg: "transparent" }}
      _active={{ bg: "transparent" }}
      leftIcon={<CaretLeft size={16} />}
      rightIcon={<Sparkle color={colors.navIconLime} />}
    >
      {t("AI Assistant")}
    </Button>
  );
}

export default Navbar;
export { AIAssistButton };
